/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  BEResponseWorkflowResponse,
  NotificaAccettazionePreventivoRequest,
  NotificaPagamentoPreventivoRequest,
  PutBackAzioniModificaBody,
  RichiestaIntegrazioneRequest,
  SendMessageRequest,
  WorkflowEvent,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Permette di sostituire l’attuale Editor della pratica con un’altra persona fisica
 * @summary Azione di subentro
 */
export const putBackAzioniSubentro = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/subentro`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPutBackAzioniSubentroMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackAzioniSubentro>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackAzioniSubentro>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackAzioniSubentro>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return putBackAzioniSubentro(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackAzioniSubentroMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackAzioniSubentro>>
>;
export type PutBackAzioniSubentroMutationBody = WorkflowEvent;
export type PutBackAzioniSubentroMutationError = ErrorType<unknown>;

/**
 * @summary Azione di subentro
 */
export const usePutBackAzioniSubentro = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackAzioniSubentro>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutBackAzioniSubentroMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * consente la modifica al nome del fascicolo
 * @summary Azione di modifica
 */
export const putBackAzioniModifica = (
  putBackAzioniModificaBody: PutBackAzioniModificaBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/modifica`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: putBackAzioniModificaBody,
    },
    options,
  );
};

export const getPutBackAzioniModificaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackAzioniModifica>>,
    TError,
    { data: PutBackAzioniModificaBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackAzioniModifica>>,
  TError,
  { data: PutBackAzioniModificaBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackAzioniModifica>>,
    { data: PutBackAzioniModificaBody }
  > = props => {
    const { data } = props ?? {};

    return putBackAzioniModifica(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackAzioniModificaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackAzioniModifica>>
>;
export type PutBackAzioniModificaMutationBody = PutBackAzioniModificaBody;
export type PutBackAzioniModificaMutationError = ErrorType<unknown>;

/**
 * @summary Azione di modifica
 */
export const usePutBackAzioniModifica = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackAzioniModifica>>,
    TError,
    { data: PutBackAzioniModificaBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutBackAzioniModificaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackAzioniModificaNomeFascicoloNomeFascicolo = (
  nomeFascicolo: string,
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/modificaNomeFascicolo/${nomeFascicolo}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPutBackAzioniModificaNomeFascicoloNomeFascicoloMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putBackAzioniModificaNomeFascicoloNomeFascicolo>
      >,
      TError,
      { nomeFascicolo: string; data: WorkflowEvent },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof putBackAzioniModificaNomeFascicoloNomeFascicolo>>,
    TError,
    { nomeFascicolo: string; data: WorkflowEvent },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof putBackAzioniModificaNomeFascicoloNomeFascicolo>
      >,
      { nomeFascicolo: string; data: WorkflowEvent }
    > = props => {
      const { nomeFascicolo, data } = props ?? {};

      return putBackAzioniModificaNomeFascicoloNomeFascicolo(
        nomeFascicolo,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutBackAzioniModificaNomeFascicoloNomeFascicoloMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putBackAzioniModificaNomeFascicoloNomeFascicolo>>
  >;
export type PutBackAzioniModificaNomeFascicoloNomeFascicoloMutationBody =
  WorkflowEvent;
export type PutBackAzioniModificaNomeFascicoloNomeFascicoloMutationError =
  ErrorType<unknown>;

export const usePutBackAzioniModificaNomeFascicoloNomeFascicolo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackAzioniModificaNomeFascicoloNomeFascicolo>>,
    TError,
    { nomeFascicolo: string; data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackAzioniModificaNomeFascicoloNomeFascicoloMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniVerificaComunicazioneCreata = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/verificaComunicazioneCreata`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniVerificaComunicazioneCreataMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniVerificaComunicazioneCreata>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniVerificaComunicazioneCreata>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniVerificaComunicazioneCreata>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniVerificaComunicazioneCreata(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniVerificaComunicazioneCreataMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniVerificaComunicazioneCreata>>
  >;
export type PostBackAzioniVerificaComunicazioneCreataMutationBody =
  WorkflowEvent;
export type PostBackAzioniVerificaComunicazioneCreataMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniVerificaComunicazioneCreata = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniVerificaComunicazioneCreata>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniVerificaComunicazioneCreataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniUfficioPadre = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/ufficioPadre`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniUfficioPadreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniUfficioPadre>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniUfficioPadre>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniUfficioPadre>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniUfficioPadre(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniUfficioPadreMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniUfficioPadre>>
>;
export type PostBackAzioniUfficioPadreMutationBody = WorkflowEvent;
export type PostBackAzioniUfficioPadreMutationError = ErrorType<unknown>;

export const usePostBackAzioniUfficioPadre = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniUfficioPadre>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackAzioniUfficioPadreMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniUfficiApprovazione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/ufficiApprovazione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniUfficiApprovazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniUfficiApprovazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniUfficiApprovazione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniUfficiApprovazione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniUfficiApprovazione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniUfficiApprovazioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniUfficiApprovazione>>
>;
export type PostBackAzioniUfficiApprovazioneMutationBody = WorkflowEvent;
export type PostBackAzioniUfficiApprovazioneMutationError = ErrorType<unknown>;

export const usePostBackAzioniUfficiApprovazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniUfficiApprovazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniUfficiApprovazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniTerminaPeriodoSospensione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/terminaPeriodoSospensione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniTerminaPeriodoSospensioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniTerminaPeriodoSospensione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniTerminaPeriodoSospensione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniTerminaPeriodoSospensione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniTerminaPeriodoSospensione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniTerminaPeriodoSospensioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniTerminaPeriodoSospensione>>
>;
export type PostBackAzioniTerminaPeriodoSospensioneMutationBody = WorkflowEvent;
export type PostBackAzioniTerminaPeriodoSospensioneMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniTerminaPeriodoSospensione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniTerminaPeriodoSospensione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniTerminaPeriodoSospensioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniSvuotaDichiarazione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/svuotaDichiarazione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniSvuotaDichiarazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniSvuotaDichiarazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniSvuotaDichiarazione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniSvuotaDichiarazione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniSvuotaDichiarazione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniSvuotaDichiarazioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniSvuotaDichiarazione>>
>;
export type PostBackAzioniSvuotaDichiarazioneMutationBody = WorkflowEvent;
export type PostBackAzioniSvuotaDichiarazioneMutationError = ErrorType<unknown>;

export const usePostBackAzioniSvuotaDichiarazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniSvuotaDichiarazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniSvuotaDichiarazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniSospendiScadenza = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/sospendiScadenza`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniSospendiScadenzaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniSospendiScadenza>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniSospendiScadenza>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniSospendiScadenza>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniSospendiScadenza(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniSospendiScadenzaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniSospendiScadenza>>
>;
export type PostBackAzioniSospendiScadenzaMutationBody = WorkflowEvent;
export type PostBackAzioniSospendiScadenzaMutationError = ErrorType<unknown>;

export const usePostBackAzioniSospendiScadenza = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniSospendiScadenza>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniSospendiScadenzaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniSincronizzaCampiSemanticiPratica = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/sincronizzaCampiSemanticiPratica`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniSincronizzaCampiSemanticiPraticaMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postBackAzioniSincronizzaCampiSemanticiPratica>
      >,
      TError,
      { data: WorkflowEvent },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniSincronizzaCampiSemanticiPratica>>,
    TError,
    { data: WorkflowEvent },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postBackAzioniSincronizzaCampiSemanticiPratica>
      >,
      { data: WorkflowEvent }
    > = props => {
      const { data } = props ?? {};

      return postBackAzioniSincronizzaCampiSemanticiPratica(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostBackAzioniSincronizzaCampiSemanticiPraticaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniSincronizzaCampiSemanticiPratica>>
  >;
export type PostBackAzioniSincronizzaCampiSemanticiPraticaMutationBody =
  WorkflowEvent;
export type PostBackAzioniSincronizzaCampiSemanticiPraticaMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniSincronizzaCampiSemanticiPratica = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniSincronizzaCampiSemanticiPratica>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniSincronizzaCampiSemanticiPraticaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniSegnalaEventoPerGruppoProcedimenti = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/segnalaEventoPerGruppoProcedimenti`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniSegnalaEventoPerGruppoProcedimentiMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postBackAzioniSegnalaEventoPerGruppoProcedimenti>
      >,
      TError,
      { data: WorkflowEvent },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postBackAzioniSegnalaEventoPerGruppoProcedimenti>
    >,
    TError,
    { data: WorkflowEvent },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postBackAzioniSegnalaEventoPerGruppoProcedimenti>
      >,
      { data: WorkflowEvent }
    > = props => {
      const { data } = props ?? {};

      return postBackAzioniSegnalaEventoPerGruppoProcedimenti(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostBackAzioniSegnalaEventoPerGruppoProcedimentiMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniSegnalaEventoPerGruppoProcedimenti>>
  >;
export type PostBackAzioniSegnalaEventoPerGruppoProcedimentiMutationBody =
  WorkflowEvent;
export type PostBackAzioniSegnalaEventoPerGruppoProcedimentiMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniSegnalaEventoPerGruppoProcedimenti = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof postBackAzioniSegnalaEventoPerGruppoProcedimenti>
    >,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniSegnalaEventoPerGruppoProcedimentiMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniSalvaCampiSemantici = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/salvaCampiSemantici`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniSalvaCampiSemanticiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniSalvaCampiSemantici>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniSalvaCampiSemantici>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniSalvaCampiSemantici>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniSalvaCampiSemantici(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniSalvaCampiSemanticiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniSalvaCampiSemantici>>
>;
export type PostBackAzioniSalvaCampiSemanticiMutationBody = WorkflowEvent;
export type PostBackAzioniSalvaCampiSemanticiMutationError = ErrorType<unknown>;

export const usePostBackAzioniSalvaCampiSemantici = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniSalvaCampiSemantici>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniSalvaCampiSemanticiMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniRimuoviProcedimentoAvviabile = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rimuoviProcedimentoAvviabile`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRimuoviProcedimentoAvviabileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRimuoviProcedimentoAvviabile>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRimuoviProcedimentoAvviabile>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRimuoviProcedimentoAvviabile>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRimuoviProcedimentoAvviabile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRimuoviProcedimentoAvviabileMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniRimuoviProcedimentoAvviabile>>
  >;
export type PostBackAzioniRimuoviProcedimentoAvviabileMutationBody =
  WorkflowEvent;
export type PostBackAzioniRimuoviProcedimentoAvviabileMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniRimuoviProcedimentoAvviabile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRimuoviProcedimentoAvviabile>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRimuoviProcedimentoAvviabileMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniRimuoviDomanda = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rimuoviDomanda`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRimuoviDomandaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRimuoviDomanda>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRimuoviDomanda>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRimuoviDomanda>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRimuoviDomanda(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRimuoviDomandaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRimuoviDomanda>>
>;
export type PostBackAzioniRimuoviDomandaMutationBody = WorkflowEvent;
export type PostBackAzioniRimuoviDomandaMutationError = ErrorType<unknown>;

export const usePostBackAzioniRimuoviDomanda = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRimuoviDomanda>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRimuoviDomandaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniRichiestaIntegrazione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/richiestaIntegrazione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRichiestaIntegrazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRichiestaIntegrazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRichiestaIntegrazione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRichiestaIntegrazione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRichiestaIntegrazione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRichiestaIntegrazioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRichiestaIntegrazione>>
>;
export type PostBackAzioniRichiestaIntegrazioneMutationBody = WorkflowEvent;
export type PostBackAzioniRichiestaIntegrazioneMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniRichiestaIntegrazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRichiestaIntegrazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRichiestaIntegrazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniRiavviaProcedimento = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/riavviaProcedimento`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRiavviaProcedimentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRiavviaProcedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRiavviaProcedimento>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRiavviaProcedimento>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRiavviaProcedimento(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRiavviaProcedimentoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRiavviaProcedimento>>
>;
export type PostBackAzioniRiavviaProcedimentoMutationBody = WorkflowEvent;
export type PostBackAzioniRiavviaProcedimentoMutationError = ErrorType<unknown>;

export const usePostBackAzioniRiavviaProcedimento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRiavviaProcedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRiavviaProcedimentoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniRiattivaScadenza = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/riattivaScadenza`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRiattivaScadenzaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRiattivaScadenza>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRiattivaScadenza>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRiattivaScadenza>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRiattivaScadenza(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRiattivaScadenzaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRiattivaScadenza>>
>;
export type PostBackAzioniRiattivaScadenzaMutationBody = WorkflowEvent;
export type PostBackAzioniRiattivaScadenzaMutationError = ErrorType<unknown>;

export const usePostBackAzioniRiattivaScadenza = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRiattivaScadenza>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRiattivaScadenzaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniRevocaPreventivo = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/revocaPreventivo`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRevocaPreventivoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRevocaPreventivo>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRevocaPreventivo>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRevocaPreventivo>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRevocaPreventivo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRevocaPreventivoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRevocaPreventivo>>
>;
export type PostBackAzioniRevocaPreventivoMutationBody = WorkflowEvent;
export type PostBackAzioniRevocaPreventivoMutationError = ErrorType<unknown>;

export const usePostBackAzioniRevocaPreventivo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRevocaPreventivo>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRevocaPreventivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniRepertoriazioneDocumento = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/repertoriazioneDocumento`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRepertoriazioneDocumentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRepertoriazioneDocumento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRepertoriazioneDocumento>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRepertoriazioneDocumento>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRepertoriazioneDocumento(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRepertoriazioneDocumentoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRepertoriazioneDocumento>>
>;
export type PostBackAzioniRepertoriazioneDocumentoMutationBody = WorkflowEvent;
export type PostBackAzioniRepertoriazioneDocumentoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniRepertoriazioneDocumento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRepertoriazioneDocumento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRepertoriazioneDocumentoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniPubblicaRichiesta = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/pubblicaRichiesta`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniPubblicaRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniPubblicaRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniPubblicaRichiesta>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniPubblicaRichiesta>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniPubblicaRichiesta(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniPubblicaRichiestaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniPubblicaRichiesta>>
>;
export type PostBackAzioniPubblicaRichiestaMutationBody = WorkflowEvent;
export type PostBackAzioniPubblicaRichiestaMutationError = ErrorType<unknown>;

export const usePostBackAzioniPubblicaRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniPubblicaRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniPubblicaRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniPubblicaProcedimento = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/pubblicaProcedimento`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniPubblicaProcedimentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniPubblicaProcedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniPubblicaProcedimento>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniPubblicaProcedimento>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniPubblicaProcedimento(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniPubblicaProcedimentoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniPubblicaProcedimento>>
>;
export type PostBackAzioniPubblicaProcedimentoMutationBody = WorkflowEvent;
export type PostBackAzioniPubblicaProcedimentoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniPubblicaProcedimento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniPubblicaProcedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniPubblicaProcedimentoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniProtocolla = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/protocolla`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniProtocollaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniProtocolla>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniProtocolla>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniProtocolla>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniProtocolla(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniProtocollaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniProtocolla>>
>;
export type PostBackAzioniProtocollaMutationBody = WorkflowEvent;
export type PostBackAzioniProtocollaMutationError = ErrorType<unknown>;

export const usePostBackAzioniProtocolla = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniProtocolla>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackAzioniProtocollaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniProtocollaRichiesta = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/protocollaRichiesta`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniProtocollaRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniProtocollaRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniProtocollaRichiesta>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniProtocollaRichiesta>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniProtocollaRichiesta(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniProtocollaRichiestaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniProtocollaRichiesta>>
>;
export type PostBackAzioniProtocollaRichiestaMutationBody = WorkflowEvent;
export type PostBackAzioniProtocollaRichiestaMutationError = ErrorType<unknown>;

export const usePostBackAzioniProtocollaRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniProtocollaRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniProtocollaRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniOmissis = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/omissis`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniOmissisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniOmissis>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniOmissis>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniOmissis>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniOmissis(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniOmissisMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniOmissis>>
>;
export type PostBackAzioniOmissisMutationBody = WorkflowEvent;
export type PostBackAzioniOmissisMutationError = ErrorType<unknown>;

export const usePostBackAzioniOmissis = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniOmissis>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackAzioniOmissisMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniNotificaPagamentoPreventivo = (
  notificaPagamentoPreventivoRequest: NotificaPagamentoPreventivoRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/notificaPagamentoPreventivo`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: notificaPagamentoPreventivoRequest,
    },
    options,
  );
};

export const getPostBackAzioniNotificaPagamentoPreventivoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniNotificaPagamentoPreventivo>>,
    TError,
    { data: NotificaPagamentoPreventivoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniNotificaPagamentoPreventivo>>,
  TError,
  { data: NotificaPagamentoPreventivoRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniNotificaPagamentoPreventivo>>,
    { data: NotificaPagamentoPreventivoRequest }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniNotificaPagamentoPreventivo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniNotificaPagamentoPreventivoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniNotificaPagamentoPreventivo>>
  >;
export type PostBackAzioniNotificaPagamentoPreventivoMutationBody =
  NotificaPagamentoPreventivoRequest;
export type PostBackAzioniNotificaPagamentoPreventivoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniNotificaPagamentoPreventivo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniNotificaPagamentoPreventivo>>,
    TError,
    { data: NotificaPagamentoPreventivoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniNotificaPagamentoPreventivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniNotificaIstruttore = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/notificaIstruttore`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniNotificaIstruttoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniNotificaIstruttore>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniNotificaIstruttore>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniNotificaIstruttore>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniNotificaIstruttore(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniNotificaIstruttoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniNotificaIstruttore>>
>;
export type PostBackAzioniNotificaIstruttoreMutationBody = WorkflowEvent;
export type PostBackAzioniNotificaIstruttoreMutationError = ErrorType<unknown>;

export const usePostBackAzioniNotificaIstruttore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniNotificaIstruttore>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniNotificaIstruttoreMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniNotificaAccettazionePreventivo = (
  notificaAccettazionePreventivoRequest: NotificaAccettazionePreventivoRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/notificaAccettazionePreventivo`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: notificaAccettazionePreventivoRequest,
    },
    options,
  );
};

export const getPostBackAzioniNotificaAccettazionePreventivoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniNotificaAccettazionePreventivo>>,
    TError,
    { data: NotificaAccettazionePreventivoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniNotificaAccettazionePreventivo>>,
  TError,
  { data: NotificaAccettazionePreventivoRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniNotificaAccettazionePreventivo>>,
    { data: NotificaAccettazionePreventivoRequest }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniNotificaAccettazionePreventivo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniNotificaAccettazionePreventivoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniNotificaAccettazionePreventivo>>
  >;
export type PostBackAzioniNotificaAccettazionePreventivoMutationBody =
  NotificaAccettazionePreventivoRequest;
export type PostBackAzioniNotificaAccettazionePreventivoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniNotificaAccettazionePreventivo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniNotificaAccettazionePreventivo>>,
    TError,
    { data: NotificaAccettazionePreventivoRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniNotificaAccettazionePreventivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniInviaTipoComunicazione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/inviaTipoComunicazione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniInviaTipoComunicazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaTipoComunicazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniInviaTipoComunicazione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniInviaTipoComunicazione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniInviaTipoComunicazione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniInviaTipoComunicazioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniInviaTipoComunicazione>>
>;
export type PostBackAzioniInviaTipoComunicazioneMutationBody = WorkflowEvent;
export type PostBackAzioniInviaTipoComunicazioneMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniInviaTipoComunicazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaTipoComunicazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniInviaTipoComunicazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniInviaRichiestaIntegrazione = (
  richiestaIntegrazioneRequest: RichiestaIntegrazioneRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/inviaRichiestaIntegrazione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: richiestaIntegrazioneRequest,
    },
    options,
  );
};

export const getPostBackAzioniInviaRichiestaIntegrazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaRichiestaIntegrazione>>,
    TError,
    { data: RichiestaIntegrazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniInviaRichiestaIntegrazione>>,
  TError,
  { data: RichiestaIntegrazioneRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniInviaRichiestaIntegrazione>>,
    { data: RichiestaIntegrazioneRequest }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniInviaRichiestaIntegrazione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniInviaRichiestaIntegrazioneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniInviaRichiestaIntegrazione>>
  >;
export type PostBackAzioniInviaRichiestaIntegrazioneMutationBody =
  RichiestaIntegrazioneRequest;
export type PostBackAzioniInviaRichiestaIntegrazioneMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniInviaRichiestaIntegrazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaRichiestaIntegrazione>>,
    TError,
    { data: RichiestaIntegrazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniInviaRichiestaIntegrazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniInviaPagamento = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/inviaPagamento`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniInviaPagamentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaPagamento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniInviaPagamento>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniInviaPagamento>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniInviaPagamento(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniInviaPagamentoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniInviaPagamento>>
>;
export type PostBackAzioniInviaPagamentoMutationBody = WorkflowEvent;
export type PostBackAzioniInviaPagamentoMutationError = ErrorType<unknown>;

export const usePostBackAzioniInviaPagamento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaPagamento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniInviaPagamentoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniInviaMessaggioDiSistema = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/inviaMessaggioDiSistema`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniInviaMessaggioDiSistemaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaMessaggioDiSistema>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniInviaMessaggioDiSistema>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniInviaMessaggioDiSistema>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniInviaMessaggioDiSistema(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniInviaMessaggioDiSistemaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniInviaMessaggioDiSistema>>
>;
export type PostBackAzioniInviaMessaggioDiSistemaMutationBody = WorkflowEvent;
export type PostBackAzioniInviaMessaggioDiSistemaMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniInviaMessaggioDiSistema = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaMessaggioDiSistema>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniInviaMessaggioDiSistemaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniInviaMessaggioAlProcedimentoPadre = (
  sendMessageRequest: SendMessageRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/inviaMessaggioAlProcedimentoPadre`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: sendMessageRequest,
    },
    options,
  );
};

export const getPostBackAzioniInviaMessaggioAlProcedimentoPadreMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postBackAzioniInviaMessaggioAlProcedimentoPadre>
      >,
      TError,
      { data: SendMessageRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaMessaggioAlProcedimentoPadre>>,
    TError,
    { data: SendMessageRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postBackAzioniInviaMessaggioAlProcedimentoPadre>
      >,
      { data: SendMessageRequest }
    > = props => {
      const { data } = props ?? {};

      return postBackAzioniInviaMessaggioAlProcedimentoPadre(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostBackAzioniInviaMessaggioAlProcedimentoPadreMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniInviaMessaggioAlProcedimentoPadre>>
  >;
export type PostBackAzioniInviaMessaggioAlProcedimentoPadreMutationBody =
  SendMessageRequest;
export type PostBackAzioniInviaMessaggioAlProcedimentoPadreMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniInviaMessaggioAlProcedimentoPadre = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaMessaggioAlProcedimentoPadre>>,
    TError,
    { data: SendMessageRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniInviaMessaggioAlProcedimentoPadreMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniInviaComunicazione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/inviaComunicazione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniInviaComunicazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaComunicazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniInviaComunicazione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniInviaComunicazione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniInviaComunicazione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniInviaComunicazioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniInviaComunicazione>>
>;
export type PostBackAzioniInviaComunicazioneMutationBody = WorkflowEvent;
export type PostBackAzioniInviaComunicazioneMutationError = ErrorType<unknown>;

export const usePostBackAzioniInviaComunicazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniInviaComunicazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniInviaComunicazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniIntegrazioneVolontaria = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/integrazioneVolontaria`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniIntegrazioneVolontariaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniIntegrazioneVolontaria>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniIntegrazioneVolontaria>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniIntegrazioneVolontaria>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniIntegrazioneVolontaria(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniIntegrazioneVolontariaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniIntegrazioneVolontaria>>
>;
export type PostBackAzioniIntegrazioneVolontariaMutationBody = WorkflowEvent;
export type PostBackAzioniIntegrazioneVolontariaMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniIntegrazioneVolontaria = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniIntegrazioneVolontaria>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniIntegrazioneVolontariaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniIntegrazioneNonAmmessa = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/integrazioneNonAmmessa`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniIntegrazioneNonAmmessaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniIntegrazioneNonAmmessa>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniIntegrazioneNonAmmessa>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniIntegrazioneNonAmmessa>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniIntegrazioneNonAmmessa(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniIntegrazioneNonAmmessaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniIntegrazioneNonAmmessa>>
>;
export type PostBackAzioniIntegrazioneNonAmmessaMutationBody = WorkflowEvent;
export type PostBackAzioniIntegrazioneNonAmmessaMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniIntegrazioneNonAmmessa = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniIntegrazioneNonAmmessa>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniIntegrazioneNonAmmessaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniIniziaPeriodoSospensione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/iniziaPeriodoSospensione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniIniziaPeriodoSospensioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniIniziaPeriodoSospensione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniIniziaPeriodoSospensione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniIniziaPeriodoSospensione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniIniziaPeriodoSospensione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniIniziaPeriodoSospensioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniIniziaPeriodoSospensione>>
>;
export type PostBackAzioniIniziaPeriodoSospensioneMutationBody = WorkflowEvent;
export type PostBackAzioniIniziaPeriodoSospensioneMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniIniziaPeriodoSospensione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniIniziaPeriodoSospensione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniIniziaPeriodoSospensioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniGestioneFascicolo = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/gestioneFascicolo`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniGestioneFascicoloMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniGestioneFascicolo>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniGestioneFascicolo>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniGestioneFascicolo>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniGestioneFascicolo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniGestioneFascicoloMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniGestioneFascicolo>>
>;
export type PostBackAzioniGestioneFascicoloMutationBody = WorkflowEvent;
export type PostBackAzioniGestioneFascicoloMutationError = ErrorType<unknown>;

export const usePostBackAzioniGestioneFascicolo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniGestioneFascicolo>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniGestioneFascicoloMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniGestioneFascicoloCustom = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/gestioneFascicoloCustom`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniGestioneFascicoloCustomMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniGestioneFascicoloCustom>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniGestioneFascicoloCustom>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniGestioneFascicoloCustom>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniGestioneFascicoloCustom(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniGestioneFascicoloCustomMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniGestioneFascicoloCustom>>
>;
export type PostBackAzioniGestioneFascicoloCustomMutationBody = WorkflowEvent;
export type PostBackAzioniGestioneFascicoloCustomMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniGestioneFascicoloCustom = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniGestioneFascicoloCustom>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniGestioneFascicoloCustomMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniGeneraProgressivo = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/generaProgressivo`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniGeneraProgressivoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniGeneraProgressivo>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniGeneraProgressivo>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniGeneraProgressivo>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniGeneraProgressivo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniGeneraProgressivoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniGeneraProgressivo>>
>;
export type PostBackAzioniGeneraProgressivoMutationBody = WorkflowEvent;
export type PostBackAzioniGeneraProgressivoMutationError = ErrorType<unknown>;

export const usePostBackAzioniGeneraProgressivo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniGeneraProgressivo>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniGeneraProgressivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniEstraiCampoDaSezioneRichiesta = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/estraiCampoDaSezioneRichiesta`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniEstraiCampoDaSezioneRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaSezioneRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaSezioneRichiesta>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaSezioneRichiesta>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniEstraiCampoDaSezioneRichiesta(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniEstraiCampoDaSezioneRichiestaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaSezioneRichiesta>>
  >;
export type PostBackAzioniEstraiCampoDaSezioneRichiestaMutationBody =
  WorkflowEvent;
export type PostBackAzioniEstraiCampoDaSezioneRichiestaMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniEstraiCampoDaSezioneRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaSezioneRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniEstraiCampoDaSezioneRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniEstraiCampoDaDichiarazione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/estraiCampoDaDichiarazione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniEstraiCampoDaDichiarazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaDichiarazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaDichiarazione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaDichiarazione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniEstraiCampoDaDichiarazione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniEstraiCampoDaDichiarazioneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaDichiarazione>>
  >;
export type PostBackAzioniEstraiCampoDaDichiarazioneMutationBody =
  WorkflowEvent;
export type PostBackAzioniEstraiCampoDaDichiarazioneMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniEstraiCampoDaDichiarazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampoDaDichiarazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniEstraiCampoDaDichiarazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniEstraiCampiSemantici = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/estraiCampiSemantici`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniEstraiCampiSemanticiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampiSemantici>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniEstraiCampiSemantici>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampiSemantici>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniEstraiCampiSemantici(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniEstraiCampiSemanticiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniEstraiCampiSemantici>>
>;
export type PostBackAzioniEstraiCampiSemanticiMutationBody = WorkflowEvent;
export type PostBackAzioniEstraiCampiSemanticiMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniEstraiCampiSemantici = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniEstraiCampiSemantici>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniEstraiCampiSemanticiMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniCreaScadenza = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/creaScadenza`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniCreaScadenzaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCreaScadenza>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniCreaScadenza>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniCreaScadenza>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniCreaScadenza(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniCreaScadenzaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniCreaScadenza>>
>;
export type PostBackAzioniCreaScadenzaMutationBody = WorkflowEvent;
export type PostBackAzioniCreaScadenzaMutationError = ErrorType<unknown>;

export const usePostBackAzioniCreaScadenza = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCreaScadenza>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackAzioniCreaScadenzaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniCreaEndoprocedimento = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/creaEndoprocedimento`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniCreaEndoprocedimentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCreaEndoprocedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniCreaEndoprocedimento>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniCreaEndoprocedimento>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniCreaEndoprocedimento(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniCreaEndoprocedimentoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniCreaEndoprocedimento>>
>;
export type PostBackAzioniCreaEndoprocedimentoMutationBody = WorkflowEvent;
export type PostBackAzioniCreaEndoprocedimentoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniCreaEndoprocedimento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCreaEndoprocedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniCreaEndoprocedimentoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniCopiapratica = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/copiapratica`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniCopiapraticaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCopiapratica>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniCopiapratica>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniCopiapratica>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniCopiapratica(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniCopiapraticaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniCopiapratica>>
>;
export type PostBackAzioniCopiapraticaMutationBody = WorkflowEvent;
export type PostBackAzioniCopiapraticaMutationError = ErrorType<unknown>;

export const usePostBackAzioniCopiapratica = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCopiapratica>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackAzioniCopiapraticaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniCaricaListaDaWsEsterno = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/caricaListaDaWsEsterno`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniCaricaListaDaWsEsternoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCaricaListaDaWsEsterno>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniCaricaListaDaWsEsterno>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniCaricaListaDaWsEsterno>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniCaricaListaDaWsEsterno(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniCaricaListaDaWsEsternoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniCaricaListaDaWsEsterno>>
>;
export type PostBackAzioniCaricaListaDaWsEsternoMutationBody = WorkflowEvent;
export type PostBackAzioniCaricaListaDaWsEsternoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniCaricaListaDaWsEsterno = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCaricaListaDaWsEsterno>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniCaricaListaDaWsEsternoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniCancellaScadenza = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/cancellaScadenza`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniCancellaScadenzaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCancellaScadenza>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniCancellaScadenza>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniCancellaScadenza>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniCancellaScadenza(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniCancellaScadenzaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniCancellaScadenza>>
>;
export type PostBackAzioniCancellaScadenzaMutationBody = WorkflowEvent;
export type PostBackAzioniCancellaScadenzaMutationError = ErrorType<unknown>;

export const usePostBackAzioniCancellaScadenza = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniCancellaScadenza>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniCancellaScadenzaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniAvviaProcedimentoDaUfficio = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/avviaProcedimentoDaUfficio`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAvviaProcedimentoDaUfficioMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAvviaProcedimentoDaUfficio>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAvviaProcedimentoDaUfficio>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAvviaProcedimentoDaUfficio>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAvviaProcedimentoDaUfficio(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAvviaProcedimentoDaUfficioMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniAvviaProcedimentoDaUfficio>>
  >;
export type PostBackAzioniAvviaProcedimentoDaUfficioMutationBody =
  WorkflowEvent;
export type PostBackAzioniAvviaProcedimentoDaUfficioMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniAvviaProcedimentoDaUfficio = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAvviaProcedimentoDaUfficio>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniAvviaProcedimentoDaUfficioMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniAvviaPratica = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/avviaPratica`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAvviaPraticaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAvviaPratica>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAvviaPratica>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAvviaPratica>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAvviaPratica(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAvviaPraticaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniAvviaPratica>>
>;
export type PostBackAzioniAvviaPraticaMutationBody = WorkflowEvent;
export type PostBackAzioniAvviaPraticaMutationError = ErrorType<unknown>;

export const usePostBackAzioniAvviaPratica = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAvviaPratica>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackAzioniAvviaPraticaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniAvviaEndoprocedimento = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/avviaEndoprocedimento`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAvviaEndoprocedimentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimento>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimento>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAvviaEndoprocedimento(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAvviaEndoprocedimentoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimento>>
>;
export type PostBackAzioniAvviaEndoprocedimentoMutationBody = WorkflowEvent;
export type PostBackAzioniAvviaEndoprocedimentoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniAvviaEndoprocedimento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniAvviaEndoprocedimentoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniAvviaEndoprocedimentoDaModulo = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/avviaEndoprocedimentoDaModulo`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAvviaEndoprocedimentoDaModuloMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimentoDaModulo>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimentoDaModulo>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimentoDaModulo>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAvviaEndoprocedimentoDaModulo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAvviaEndoprocedimentoDaModuloMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimentoDaModulo>>
  >;
export type PostBackAzioniAvviaEndoprocedimentoDaModuloMutationBody =
  WorkflowEvent;
export type PostBackAzioniAvviaEndoprocedimentoDaModuloMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniAvviaEndoprocedimentoDaModulo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAvviaEndoprocedimentoDaModulo>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniAvviaEndoprocedimentoDaModuloMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniArchiviaCronologiaProcedimento = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/archiviaCronologiaProcedimento`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniArchiviaCronologiaProcedimentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimento>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimento>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniArchiviaCronologiaProcedimento(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniArchiviaCronologiaProcedimentoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimento>>
  >;
export type PostBackAzioniArchiviaCronologiaProcedimentoMutationBody =
  WorkflowEvent;
export type PostBackAzioniArchiviaCronologiaProcedimentoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniArchiviaCronologiaProcedimento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniArchiviaCronologiaProcedimentoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniArchiviaCronologiaProcedimentoMinio = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/archiviaCronologiaProcedimentoMinio`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniArchiviaCronologiaProcedimentoMinioMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimentoMinio>
      >,
      TError,
      { data: WorkflowEvent },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimentoMinio>
    >,
    TError,
    { data: WorkflowEvent },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimentoMinio>
      >,
      { data: WorkflowEvent }
    > = props => {
      const { data } = props ?? {};

      return postBackAzioniArchiviaCronologiaProcedimentoMinio(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostBackAzioniArchiviaCronologiaProcedimentoMinioMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimentoMinio>
    >
  >;
export type PostBackAzioniArchiviaCronologiaProcedimentoMinioMutationBody =
  WorkflowEvent;
export type PostBackAzioniArchiviaCronologiaProcedimentoMinioMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniArchiviaCronologiaProcedimentoMinio = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof postBackAzioniArchiviaCronologiaProcedimentoMinio>
    >,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniArchiviaCronologiaProcedimentoMinioMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
export const postBackAzioniAnnullaValiditaDocumento = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/annullaValiditaDocumento`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAnnullaValiditaDocumentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAnnullaValiditaDocumento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAnnullaValiditaDocumento>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAnnullaValiditaDocumento>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAnnullaValiditaDocumento(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAnnullaValiditaDocumentoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniAnnullaValiditaDocumento>>
>;
export type PostBackAzioniAnnullaValiditaDocumentoMutationBody = WorkflowEvent;
export type PostBackAzioniAnnullaValiditaDocumentoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniAnnullaValiditaDocumento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAnnullaValiditaDocumento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniAnnullaValiditaDocumentoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniAggiungiProcedimentoAvviabile = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/aggiungiProcedimentoAvviabile`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAggiungiProcedimentoAvviabileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiungiProcedimentoAvviabile>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAggiungiProcedimentoAvviabile>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAggiungiProcedimentoAvviabile>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAggiungiProcedimentoAvviabile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAggiungiProcedimentoAvviabileMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniAggiungiProcedimentoAvviabile>>
  >;
export type PostBackAzioniAggiungiProcedimentoAvviabileMutationBody =
  WorkflowEvent;
export type PostBackAzioniAggiungiProcedimentoAvviabileMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniAggiungiProcedimentoAvviabile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiungiProcedimentoAvviabile>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniAggiungiProcedimentoAvviabileMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniAggiungiDomanda = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/aggiungiDomanda`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAggiungiDomandaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiungiDomanda>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAggiungiDomanda>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAggiungiDomanda>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAggiungiDomanda(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAggiungiDomandaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniAggiungiDomanda>>
>;
export type PostBackAzioniAggiungiDomandaMutationBody = WorkflowEvent;
export type PostBackAzioniAggiungiDomandaMutationError = ErrorType<unknown>;

export const usePostBackAzioniAggiungiDomanda = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiungiDomanda>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniAggiungiDomandaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniAggiornaOggetto = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/aggiornaOggetto`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAggiornaOggettoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiornaOggetto>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAggiornaOggetto>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAggiornaOggetto>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAggiornaOggetto(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAggiornaOggettoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniAggiornaOggetto>>
>;
export type PostBackAzioniAggiornaOggettoMutationBody = WorkflowEvent;
export type PostBackAzioniAggiornaOggettoMutationError = ErrorType<unknown>;

export const usePostBackAzioniAggiornaOggetto = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiornaOggetto>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniAggiornaOggettoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniAggiornaIdIstanzaProcedimento = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/aggiornaIdIstanzaProcedimento`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAggiornaIdIstanzaProcedimentoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiornaIdIstanzaProcedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAggiornaIdIstanzaProcedimento>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAggiornaIdIstanzaProcedimento>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAggiornaIdIstanzaProcedimento(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAggiornaIdIstanzaProcedimentoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniAggiornaIdIstanzaProcedimento>>
  >;
export type PostBackAzioniAggiornaIdIstanzaProcedimentoMutationBody =
  WorkflowEvent;
export type PostBackAzioniAggiornaIdIstanzaProcedimentoMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniAggiornaIdIstanzaProcedimento = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiornaIdIstanzaProcedimento>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniAggiornaIdIstanzaProcedimentoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary aggiorna fase di un istanzaProcedimento
 */
export const postBackAzioniAggiornaFase = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/aggiornaFase`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAggiornaFaseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiornaFase>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAggiornaFase>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAggiornaFase>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAggiornaFase(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAggiornaFaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniAggiornaFase>>
>;
export type PostBackAzioniAggiornaFaseMutationBody = WorkflowEvent;
export type PostBackAzioniAggiornaFaseMutationError = ErrorType<unknown>;

/**
 * @summary aggiorna fase di un istanzaProcedimento
 */
export const usePostBackAzioniAggiornaFase = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiornaFase>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackAzioniAggiornaFaseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniAggiornaFaseDaBdu = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/aggiornaFaseDaBdu`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniAggiornaFaseDaBduMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiornaFaseDaBdu>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniAggiornaFaseDaBdu>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniAggiornaFaseDaBdu>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniAggiornaFaseDaBdu(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniAggiornaFaseDaBduMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniAggiornaFaseDaBdu>>
>;
export type PostBackAzioniAggiornaFaseDaBduMutationBody = WorkflowEvent;
export type PostBackAzioniAggiornaFaseDaBduMutationError = ErrorType<unknown>;

export const usePostBackAzioniAggiornaFaseDaBdu = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniAggiornaFaseDaBdu>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniAggiornaFaseDaBduMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackAzioniGestisciPersonaGiuridica = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/gestisciPersonaGiuridica`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniGestisciPersonaGiuridicaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniGestisciPersonaGiuridica>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniGestisciPersonaGiuridica>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniGestisciPersonaGiuridica>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniGestisciPersonaGiuridica(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniGestisciPersonaGiuridicaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniGestisciPersonaGiuridica>>
>;
export type PostBackAzioniGestisciPersonaGiuridicaMutationBody = WorkflowEvent;
export type PostBackAzioniGestisciPersonaGiuridicaMutationError =
  ErrorType<unknown>;

export const usePostBackAzioniGestisciPersonaGiuridica = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniGestisciPersonaGiuridica>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniGestisciPersonaGiuridicaMutationOptions(options);

  return useMutation(mutationOptions);
};
